import AlarmIcon from "@mui/icons-material/Alarm";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import ConstructionIcon from "@mui/icons-material/Construction";
import DashboardIcon from "@mui/icons-material/Dashboard";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import MailIcon from "@mui/icons-material/Mail";
import MoneyOffIcon from "@mui/icons-material/MoneyOff";
import NewReleasesIcon from "@mui/icons-material/NewReleases";
import ReceiptIcon from "@mui/icons-material/Receipt";
import ReportIcon from "@mui/icons-material/Report";
import RequestQuoteIcon from "@mui/icons-material/RequestQuote";
import SavingsIcon from "@mui/icons-material/Savings";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import WatchLaterIcon from "@mui/icons-material/WatchLater";
import { Route } from ".";
import Account from "./views/Account/Account";
import Entity from "./views/Common/Entity";
import Configuration from "./views/Configuration/Configuration";
import Dashboard from "./views/Dashboard/Dashboard";
import Despesas from "./views/Despesas/Despesas";
import EntradasMaterial from "./views/EntradasMaterial/EntradasMaterial";
import { Entrega } from "./views/Entregas/Entrega";
import Faturacao from "./views/Faturacao/Faturacao";
import { MonitorizacaoPicagens } from "./views/MonitorizacaoPicagens";
import { NaoConformidades } from "./views/NaoConformidades";
import NotasCredito from "./views/NotasCredito/NotasCredito";
import NotasEncomenda from "./views/NotasEncomenda/NotasEncomenda";
import { ObraForm } from "./views/Obras/newObra/ObraForm";
import Obras from "./views/Obras/Obras";
import ObraWrapper from "./views/Obras/ObraWrapper";
import Ocorrencias from "./views/Ocorrencias/Ocorrencias";
import Orcamento from "./views/Orcamentos/newOrcamentos";
import OrcamentosForm from "./views/Orcamentos/newOrcamentos/OrcamentosForm";
import Orcamentos from "./views/Orcamentos/Orcamentos";
import PedidosOrcamento from "./views/PedidosOrcamento";
import PedidoOrcamento from "./views/PedidosOrcamento/PedidoOrcamento";
import OperacoesWrapper from "./views/Peças/Operacoes/OperacoesWrapper";
import PecasWrapper from "./views/Peças/PecasWrapper";
import { PicaPonto } from "./views/PicaPonto";
import Recibos from "./views/Recibos/Recibos";
import { VersionNotesDisplayer } from "./views/VersionNotes";

export const routes: Route[] = [
	{
		path: "/",
		name: "Dashboard",
		component: <Dashboard />,
		icon: <DashboardIcon />,
		access: ["admin", "user"],
	},
	{
		path: "/orcamentos",
		name: "Orçamentos",
		component: <Orcamentos />,
		icon: <RequestQuoteIcon />,
		access: ["admin"],
	},
	{
		path: "/pedidos-orcamento",
		name: "Pedidos de Orçamento",
		component: <PedidosOrcamento />,
		icon: <MailIcon />,
		access: ["admin"],
	},
	{
		path: "/pedidos-orcamento/:id",
		component: <PedidoOrcamento />,
		hidden: true,
		access: ["admin"],
	},
	{
		path: "/orcamentos/custom-form",
		name: "Orçamentos",
		component: <OrcamentosForm orcamento={null} />,
		access: ["admin"],
		hidden: true,
	},
	{
		path: "/orcamentos/:id",
		component: <Orcamento />,
		hidden: true,
		access: ["admin"],
	},

	{
		path: "/despesas",
		name: "Despesas",
		component: <Despesas />,
		icon: <MoneyOffIcon />,
		access: ["admin"],
	},
	{
		path: "/despesas/:id",
		component: <Entity />,
		hidden: true,
		access: ["admin"],
	},
	{
		path: "/notas-credito",
		name: "Notas de Crédito",
		component: <NotasCredito />,
		icon: <SavingsIcon />,
		access: ["admin"],
	},
	{
		path: "/notas-credito-clientes/:id",
		component: <Entity />,
		hidden: true,
		access: ["admin"],
	},
	{
		path: "/notas-credito-fornecedores/:id",
		component: <Entity />,
		hidden: true,
		access: ["admin"],
	},
	{
		name: "Faturação",
		path: "/faturacao",
		component: <Faturacao />,
		icon: <AttachMoneyIcon />,
		access: ["admin"],
	},
	{
		path: "/faturacao-clientes/:id",
		component: <Entity />,
		hidden: true,
		access: ["admin"],
	},

	{
		path: "/faturacao-fornecedores/:id",
		component: <Entity />,
		hidden: true,
		access: ["admin"],
	},
	{
		name: "Obras",
		path: "/obras",
		access: ["admin", "user"],
		component: <Obras />,
		icon: <ConstructionIcon />,
	},
	{
		path: "/obras/custom-form",
		name: "Obras",
		component: <ObraForm />,
		access: ["admin"],
		hidden: true,
	},
	{
		path: "/obras/:id",
		component: <ObraWrapper />,
		hidden: true,
		access: ["admin", "user"],
	},
	{
		path: "/obras/:obraId/pecas/:id",
		component: <PecasWrapper />,
		hidden: true,
		access: ["admin", "user"],
	},
	{
		path: "/obras/:obraId/entregas/:id",
		component: <Entrega />,
		hidden: true,
		access: ["admin", "user"],
	},
	{
		path: "obras/:obraId/pecas/:pecasId/operacoes/:operationType/:operationId",
		component: <OperacoesWrapper />,
		hidden: true,
		access: ["admin"],
	},
	{
		name: "Recibos",
		path: "/recibos",
		component: <Recibos />,
		icon: <ReceiptIcon />,
		access: ["admin"],
	},
	{
		path: "/recibos/:id",
		component: <Entity />,
		hidden: true,
		access: ["admin"],
	},

	{
		name: "Conta",
		path: "/utilizadores",
		component: <Account />,
		hidden: true,
		access: ["admin"],
	},
	{
		path: "/utilizadores/:id",
		component: <Entity />,
		hidden: true,
		access: ["admin"],
	},
	{
		path: "/materiais/:id",
		component: <Entity />,
		hidden: true,
		access: ["admin"],
	},
	{
		name: "Configurações",
		path: "/configurations",
		component: <Configuration />,
		hidden: true,
		access: ["admin"],
	},
	{
		path: "notificacoes/configurations/:id",
		component: <Entity />,
		hidden: true,
		access: ["admin"],
	},
	{
		name: "Clientes",
		path: "clients/:id",
		component: <Entity />,
		hidden: true,
		access: ["admin"],
	},
	{
		name: "Máquinas",
		path: "machines/:id",
		component: <Entity />,
		hidden: true,
		access: ["admin"],
	},
	{
		path: "fornecedores/:id",
		component: <Entity />,
		hidden: true,
		access: ["admin"],
	},
	{
		name: "Notas Encomenda",
		path: "/notas-encomenda",
		component: <NotasEncomenda />,
		icon: <ShoppingCartIcon />,
		access: ["admin"],
	},
	{
		name: "Notas Encomenda",
		path: "notas-encomenda/:id",
		component: <Entity />,
		hidden: true,
		access: ["admin"],
	},
	{
		path: "/entradas-material",
		name: "Entradas material",
		component: <EntradasMaterial />,
		icon: <LocalShippingIcon />,
		access: ["admin", "user"],
	},
	{
		path: "/entradas-material/:id",
		component: <Entity />,
		hidden: true,
		access: ["admin", "user"],
	},
	{
		path: "/ocorrencias",
		name: "Ocorrências",
		component: <Ocorrencias />,
		icon: <ReportIcon />,
		access: ["admin", "user"],
	},
	{
		path: "/ocorrencias/:id",
		component: <Entity />,
		hidden: true,
		access: ["admin", "user"],
	},
	{
		path: "version-notes",
		component: <VersionNotesDisplayer />,
		hidden: true,
		access: ["admin", "user"],
	},
	{
		name: "Monitorização picagens",
		path: "/historico-picagens",
		component: <MonitorizacaoPicagens />,
		icon: <AlarmIcon />,
		access: ["admin"],
	},
	{
		name: "Máquina de ponto",
		path: "/maquina-ponto",
		component: <PicaPonto />,
		icon: <WatchLaterIcon />,
		hidden: true,
		access: ["admin"],
	},
	{
		name: "Não conformidades",
		path: "/nao-conformidades",
		component: <NaoConformidades />,
		icon: <NewReleasesIcon />,
		access: ["admin", "user"],
	},
	{
		path: "/nao-conformidades-clientes/:id",
		component: <Entity />,
		hidden: true,
		access: ["admin", "user"],
	},
	{
		path: "/nao-conformidades-fornecedores/:id",
		component: <Entity />,
		hidden: true,
		access: ["admin", "user"],
	},
];
